import { useScreenPermission } from "@/hooks/useScreenPermission";

interface Props {
  screen: string;
  children: React.ReactNode;
}

export default function PermissionGuard({ screen, children }: Props) {
  const { loading, canView } = useScreenPermission(screen);

  if (loading) {
    return (
      <div className="flex items-center justify-center py-20">
        <div className="w-8 h-8 border-4 border-brand-500 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!canView) {
    return (
      <div className="flex flex-col items-center justify-center py-20 text-gray-400">
        <p className="text-lg font-semibold">Access Denied</p>
        <p className="text-sm mt-1">You don't have permission to view this page.</p>
      </div>
    );
  }

  return <>{children}</>;
}
